export const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};

export const headingStyles = ({ palette }) => ({
  color: palette.text.secondary,
});

export const listStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};

export const messageStyles = ({ palette }) => ({
  color: palette.text.secondary,
});
